export enum PROPOSAL_STEPS {
	previousBlock = 'previousBlock',
	summaryBlock = 'summaryBlock',
	consentBlock = 'consentBlock',
	receiptBlock = 'receiptBlock',
}

export enum POLICY_FIELDS {
	cover_start_date = 'cover_start_date',
	cancelExistingPolicy = 'cancelExistingPolicy',
	cancelExistingPolicyText = 'cancelExistingPolicyText',
	payment_method = 'payment_method',
	payment_frequency = 'payment_frequency',
	reg_no = 'reg_no',
	account = 'account',
	previous_company_id = 'previous_company_id',
	previous_policy_id = 'previous_policy_id',
	termination_option = 'termination_option', // formerly takeover_date
	consent_summary = 'consent_summery',
	total_fees = 'total_fees',
	total_price = 'total_price',
	product_price_template = 'product_price_template',
	product_affinity_template = 'product_affinity_template',
}

export enum INPUT_TYPES {
	TextField = 'TextField',
	TextOnlyField = 'TextOnlyField',
	NumberField = 'NumberField',
	DatePickerField = 'DatePickerField',
	RadioButtonField = 'RadioButtonField',
	CheckField = 'CheckField',
	TextSearchField = 'TextSearchField',
	DropDownField = 'DropDownField',
	AddressSearchField = 'AddressSearchField',
}
